import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Col, FormFeedback } from 'reactstrap';
import { format } from '@breezeway/brzw-react-core';
import InternationalPhone from './international_phone';

const InternationalPhoneControl = props => {
  const { defaultCountry, id, placeholder, label, preferredCountries, children, required } = props;

  const countryCodeInput = props[props.names[0]].input;
  const countryDialCodeInput = props[props.names[1]].input;
  const phoneNumberInput = props[props.names[2]].input;
  const phoneNumberMeta = props[props.names[2]].meta;

  let validationState = null;
  let errorText = null;
  if (phoneNumberMeta.touched) {
    if (phoneNumberMeta.error) {
      validationState = 'danger';
      errorText = phoneNumberMeta.error;
    } else {
      validationState = 'success';
    }
  }

  return (
    <FormGroup row color={validationState} className="international-phone-control form-group-row">
      <div className="international-phone-control__container">
        <Label for={id} className="form-group-row__label">
          {required ? (
            <span>
              {label} <span className="text-orange">*</span>
            </span>
          ) : (
            label
          )}
        </Label>
        <Col className="form-group-row__col">
          <InternationalPhone
            {...phoneNumberInput}
            id={id}
            onChange={(number, code, dialCode) => {
              countryCodeInput.onChange(code);
              phoneNumberInput.onChange(format.phone.cleanNumber(number, dialCode));
              countryDialCodeInput.onChange(dialCode);
            }}
            onBlur={(number, code, dialCode) => {
              countryCodeInput.onBlur(code);
              phoneNumberInput.onBlur(format.phone.cleanNumber(number, dialCode));
              countryDialCodeInput.onChange(dialCode);
            }}
            defaultCountry={defaultCountry || countryCodeInput.value}
            preferredCountries={preferredCountries}
            placeholder={placeholder}
          />
          {errorText && <FormFeedback>{errorText}</FormFeedback>}
          {children}
        </Col>
      </div>
    </FormGroup>
  );
};

InternationalPhoneControl.propTypes = {
  children: PropTypes.node,
  names: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.string,
  type: PropTypes.string,
  defaultCountry: PropTypes.string,
  preferredCountries: PropTypes.arrayOf(PropTypes.string),
  placeholder: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  rows: PropTypes.number,
  meta: PropTypes.shape({}),
  required: PropTypes.bool,
};

InternationalPhoneControl.defaultProps = {
  defaultCountry: null,
  required: false,
};

export default InternationalPhoneControl;
